<div class="govuk-width-container govuk-width-container-custom">

    <main class="govuk-main-wrapper">

        <div class="govuk-grid-row">
            <div class="govuk-grid-column-full">
                <h1 class="govuk-heading-l">{{estoreError}}</h1>
                <h2 class="govuk-heading-m"> {{'ESTORE_FAIL.INFO' | translate}}</h2>

                <br>
            </div>

            <div class="wrapper wrap pb-120 soft--medium pull-up">

                <!-- <app-member-bar></app-member-bar> -->

                <alert role="alert"></alert>

                <div class="govuk-grid-row">
                    <div class="govuk-grid-column-full">

                        <div class="govuk-grid-row">
                            <div class="govuk-grid-column-full">
                                <button *ngIf="!mobile()" class="govuk-button btn btn-primary"
                                    data-module="govuk-button" (click)="restartJourney()">
                                    <svg class="govuk-button__start-icon back-button-svg"
                                        xmlns="http://www.w3.org/2000/svg" width="17.5" height="19" viewBox="0 0 33 40"
                                        aria-hidden="true" focusable="false">
                                        <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
                                    </svg>
                                    {{'ESTORE_FAIL.GOBACK' |
                                    translate}}</button>
                                <button class="govuk-button btn btn-primary float-right" data-module="govuk-button"
                                    type="button" style="margin-left: 30px;" (click)="retry()">{{'ESTORE_FAIL.RETRY'
                                    |
                                    translate}}</button>
                                <button *ngIf="mobile()" class="govuk-button btn btn-primary" data-module="govuk-button"
                                    (click)="restartJourney()">
                                    <svg class="govuk-button__start-icon back-button-svg"
                                        xmlns="http://www.w3.org/2000/svg" width="17.5" height="19" viewBox="0 0 33 40"
                                        aria-hidden="true" focusable="false">
                                        <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z" />
                                    </svg>
                                    {{'ESTORE_FAIL.GOBACK' | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>